var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppGalleryBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.255 0H7.744A7.729 7.729 0 0 0 0 7.745v20.51A7.729 7.729 0 0 0 7.745 36h20.51A7.729 7.729 0 0 0 36 28.255V7.744C36 3.491 32.51 0 28.255 0ZM7.817 22.436h-.982V20.51H4.655v1.927h-.982V17.71h.982V19.6h2.181v-1.89h.982v4.726Zm5.455-2.072c0 1.345-.764 2.109-2.073 2.109-1.31 0-2.073-.764-2.073-2.073v-2.69h.982v2.654c0 .8.4 1.2 1.091 1.2.69 0 1.09-.4 1.09-1.164v-2.69h.983v2.654Zm4.545 2.072-.436-.982H15.2l-.036.073-.4.91h-.982l2.109-4.728h.836l.037.037 2.109 4.69h-1.055Zm6.146 0h-.8l-1.091-3.09-1.091 3.09h-.8l-1.673-4.727h1.018l1.055 3.236 1.09-3.236h.8l1.092 3.236 1.054-3.236h1.018l-1.672 4.727ZM17.89 9.346c-3.818 0-7.164-1.637-9.164-4.946-.545 0-.982-.473-.982-1.018 0-.582.473-1.018 1.019-1.018.581 0 1.018.472 1.018 1.018 0 .254-.11.509-.255.69 2 2.8 5.019 4.4 8.364 4.4 3.345 0 6.4-1.636 8.4-4.472a.988.988 0 0 1-.218-.618 1.04 1.04 0 0 1 1.018-1.018c.545 0 1.018.436 1.018 1.018A1.04 1.04 0 0 1 27.091 4.4h-.037c-1.963 3.273-5.345 4.91-9.163 4.945Zm12.145 13.09H26.4V17.71h3.527v.873h-2.545v.982h1.782v.872h-1.782V21.6h2.654v.836Zm2.11 0H31.2V17.71h.945v4.727Z",
    fill: "#25282B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.636 20.473-.072.109h1.49l-.072-.11-.691-1.563-.655 1.564Z",
    fill: "#25282B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppGalleryBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/app_gallery__black.80b3533c65cc5152bebec491b914106c.svg";